

import React from 'react';
import { Row, Col, Space } from "antd";
import { Box, Button, TextField, Typography, FormControlLabel, Switch } from "@mui/material";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import customStyles from "../../../../../assets/styles/customStyles";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { useSelector } from "react-redux";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import moment from 'moment';
import { AESEncrypt } from "../../../../../helpers/Crypto";
import { capitalizeFirstLetter } from "../../../../../helpers/utilities";
import dayjs from 'dayjs';


export const CustomForm = (props) => {
    const { submitPlan, changeHandler, form, error, type, editLoader, createLoader, handleSync, readDetails } = props;
    const { providerDetails } = useSelector(state => state.younoteAdminProductReducer);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    const classes = customStyles();
    return (
        <Box
            className={clsx(classes.removeUnderline, classes.viewPlanDetails)}
            component="form"
            autoComplete="off"
            onSubmit={(e) => submitPlan(e)}>
            <Row gutter={100}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignRight}>
                    <Space direction="horizontal" align="center">
                        {
                            form.id && !form?.vendorReferenceId && readDetails?.provider?.type === 'EXTERNAL' && <NavLink to="#"
                                onClick={() => handleSync()} className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}>Sync</NavLink>
                        }
                        {
                            type === 'view' ? <NavLink to={`/younote-admin/common/plan-details/${AESEncrypt(form.id)}/edit`}
                                className={clsx(classes.modalBtn)}>Edit</NavLink> : <Button
                                    key="save"
                                    color="primary"
                                    variant="contained"
                                    type={'submit'}
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                >{form.id ? 'Update' : 'Save'}</Button>
                        }
                    </Space>
                </Col>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Row gutter={100}>
                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Row gutter={100}>
                                <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                    {
                                        type === 'view' ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Plan ID</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.planId}</Typography>
                                        </> : <TextField autoComplete='one-time-code'
                                            label={["Plan ID ", <span key={"Plan ID"} className={classes.colorRedRequired}> *</span>]}
                                            variant={'standard'}
                                            error={error.planId ? true : false}
                                            helperText={error.planId}
                                            name={"planId"}
                                            fullWidth
                                            value={form?.planId}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.planId
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    }

                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                    {
                                        type === 'view' ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.planNameView, 'MuiInputLabel-shrink', classes.fonSize13)}>Plan Name</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.planName}</Typography>
                                        </> : <TextField autoComplete='one-time-code'
                                            label={["Plan Name ", <span key={"Plan Name"} className={classes.colorRedRequired}> *</span>]}
                                            variant={'standard'}
                                            error={error.planName ? true : false}
                                            helperText={error.planName}
                                            name={"planName"}
                                            className={classes.feature}
                                            fullWidth
                                            value={form?.planName}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.planName
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    }
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                    {
                                        type === 'view' ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.actualPlanAmountView, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Actual Plan Amount</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.actualPlanAmount}</Typography>
                                        </> : <TextField autoComplete='one-time-code'
                                            label={["Actual Plan Amount ", <span key={"Actual Plan Amount"} className={classes.colorRedRequired}> *</span>]}
                                            variant={'standard'}
                                            className={classes.actualPlanAmount}

                                            error={error.actualPlanAmount ? true : false}
                                            helperText={error.actualPlanAmount}
                                            name={"actualPlanAmount"}
                                            fullWidth
                                            type={"number"}
                                            value={form?.actualPlanAmount}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }, inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                                shrink: form?.actualPlanAmount
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    }
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                    {
                                        type === 'view' ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Plan Amount</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.planAmount}</Typography>
                                        </> : <TextField autoComplete='one-time-code'
                                            label={["Plan Amount ", <span key={"Actual Plan Amount"} className={classes.colorRedRequired}> *</span>]}
                                            variant={'standard'}
                                            error={error.planAmount ? true : false}
                                            helperText={error.planAmount}
                                            className={classes.planAmount}

                                            name={"planAmount"}
                                            type={"number"}
                                            fullWidth
                                            value={form?.planAmount}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                inputProps: { step: "any" }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom, shrink: form?.planAmount
                                            }}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.actualPlanDescriptionView, 'MuiInputLabel-shrink', classes.fonSize13)}>Plan Description</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                </> : <TextField autoComplete='one-time-code'
                                    label={["Plan Description"]}
                                    name={"description"}
                                    multiline
                                    variant="outlined"
                                    fullWidth
                                    value={form?.description}
                                    className={clsx(clsx(classes.customDescription, classes.planDescription))}
                                    rows={3}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColor,
                                        shrink: form?.description
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Allowed User</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.allowedUsers}</Typography>
                                </> : <TextField autoComplete='one-time-code'
                                    label={["Allowed User", <span key={"Allowed User"} className={classes.colorRedRequired}> *</span>]}
                                    name={"allowedUsers"}
                                    variant="standard"
                                    fullWidth
                                    type={"number"}
                                    value={form?.allowedUsers}
                                    error={error.allowedUsers ? true : false}
                                    className={classes.margin20t}
                                    helperText={error.allowedUsers}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                        shrink: form?.allowedUsers
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Subscription Provider</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.provider?.name}</Typography>
                                </> : <AutoCompleteComponent
                                    name={["Subscription Provider ", <span key={"Subscription Provider"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' },
                                    { 'key': 'providerId', 'name': 'Provider ID' }]}
                                    details={providerDetails}
                                    parentValue={customObject(providerDetails, form.providerId)}
                                    onChange={(data) => changeHandler(data, 'providerId')}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                    parentError={error.providerId}
                                />
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, type === 'view' ? classes.margin30t : classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Subscription Provider ID</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.provider?.providerId || '---'}</Typography>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Status</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.status ? capitalizeFirstLetter(form?.status) : '---'}</Typography></> : <>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => changeHandler(!form?.checkStatus, 'checkStatus')}
                                            checked={form?.checkStatus}
                                        />}
                                        label="Status"
                                        labelPlacement="top"
                                        className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                    />
                                </>
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Plan Type</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.planType || '---'}</Typography>
                                </> : <AutoCompleteComponent
                                    name={["Plan Type ", <span key={"Plan Type"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={[{ id: 'ONE-TIME', name: 'One Time' }, { id: 'RECURRING', name: 'Recurring' }]}
                                    parentValue={customObject([{ id: 'ONE-TIME', name: 'One Time' }, { id: 'RECURRING', name: 'Recurring' }], form.planType)}
                                    onChange={(data) => changeHandler(data.id, 'planType')}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                    parentError={error.planType}
                                />
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Frequency</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.frequency || '---'}</Typography>
                                </> : <AutoCompleteComponent
                                    name={["Frequency ", <span key={"Frequency"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={[{ id: 'WEEKLY', name: 'Weekly' }, { id: 'MONTHLY', name: 'Monthly' }, { id: 'YEARLY', name: 'Yearly' }]}
                                    parentValue={customObject([{ id: 'WEEKLY', name: 'Weekly' }, { id: 'MONTHLY', name: 'Monthly' }, { id: 'YEARLY', name: 'Yearly' }], form.frequency)}
                                    onChange={(data) => changeHandler(data.id, 'frequency')}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                    parentError={error.frequency}
                                />
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>Start Date</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.startDate ? moment(form?.startDate).format('DD/MM/YYYY') : '---'}</Typography>
                                </> : <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={form?.startDate ? dayjs(form?.startDate).$d : new Date()}
                                            label={["Start Date ", <span key={"Start Date"} className={classes.colorRedRequired}> *</span>]}
                                            slotProps={{
                                                textField: {
                                                    error: error.startDate ? true : false,
                                                    helperText: error.startDate,
                                                },
                                            }}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor
                                                },
                                                inputProps: { value: moment(form?.startDate).format('DD/MM/YYYY'), readOnly: false }
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue, newError) => {
                                                if (newError?.validationError) {
                                                    changeHandler(new Date(), 'startDate');
                                                } else {
                                                    changeHandler(newValue, 'startDate');
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            {
                                type === 'view' ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin30t, 'MuiInputLabel-shrink', classes.fonSize13)}>End Date</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.endDate ? moment(form?.endDate).format('DD/MM/YYYY') : '---'}</Typography>
                                </> : <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            minDate={form?.startDate}
                                            views={['year', 'month', 'day']}
                                            value={form?.endDate ? dayjs(form?.endDate).$d : new Date()}
                                            label={["End Date ", <span key={"End Date"} className={classes.colorRedRequired}> *</span>]}
                                            slotProps={{
                                                textField: {
                                                    error: error.endDate ? true : false,
                                                    helperText: error.endDate,
                                                },
                                            }}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor
                                                },
                                                inputProps: { value: moment(form?.endDate).format('DD/MM/YYYY'), readOnly: false }
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue, newError) => {
                                                if (newError?.validationError) {
                                                    changeHandler(new Date(), 'endDate');
                                                } else {
                                                    changeHandler(newValue, 'endDate');
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            }
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, type === 'view' ? classes.margin30t : classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Vendor Reference ID</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.vendorReferenceId || '---'}</Typography>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Box>
    )
}